import { render, staticRenderFns } from "./NewStuAdjustModal.vue?vue&type=template&id=23d658fa&scoped=true&"
import script from "./NewStuAdjustModal.vue?vue&type=script&lang=js&"
export * from "./NewStuAdjustModal.vue?vue&type=script&lang=js&"
import style0 from "./NewStuAdjustModal.vue?vue&type=style&index=0&id=23d658fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d658fa",
  null
  
)

export default component.exports